module.exports = __webpack_public_path__ + "static/media/frozen5.5f92b3df.png";